import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { FullscreenFallback } from "../DialogComponents/DialogFallback/FullscreenFallback";
import { styledHeaderText } from "../styled";

export const Export: FC = () => {
  const { t } = useTranslation("dialogs");

  return (
    <FullscreenFallback
      context={{
        title: {
          text: styledHeaderText(t("export.dialogHeader")),
          icon: "download",
        },
      }}
    />
  );
};
